<template lang="pug">

ul.loading-text
  li(v-bind:class="{'active': textIndex === 0}")
    img(v-if="locale === 'en'" src="~assets/unsupported/lockup.png")
    img(v-if="locale !== 'en'" src="~assets/lockup.png")
  li(
    v-for="(lines, index) in text"
    v-bind:class="{'active': textIndex === (index + 1)}"
  )
    p(v-for="line in lines") {{ line }}
    //- p {{ item }}


</template>

<script>
import i18n from 'src/i18n'

export default {
  name: 'loading-text',
  components: {

  },
  props: [
    'completed'
  ],
  data () {
    return {
      textIndex: 1,
      text: this.$t('loading'),
      locale: i18n.locale
    }
  },
  computed: {

  },
  mounted: function() {
    this.interval = setInterval(this.nextText, 3000)

    // this.text = this.$t('loading')
    // for (let key in this.text) {

    // }

  },
  beforeDestroy: function() {

  },
  methods: {
    nextText () {
      this.textIndex++
      if (this.textIndex > this.text.length) this.textIndex = 1
    }
  },
  watch: {
    completed (val) {
      if (!val) return
      clearInterval(this.interval)
      this.textIndex = 0
    }
  }
}
</script>

<style lang="sass" scoped>
@import "src/common.sass"

.loading-text
  position: relative
  height: 50px
  width: 100%
  text-align: center
  font-size: 1.2rem
  text-transform: uppercase
  font-style: italic

  li
    +full()
    +flex-center()
    justify-content: flex-end
    white-space: pre-wrap
    opacity: 0
    transition: all 0.4s ease 0s

    img
      position: absolute
      bottom: 6px
      left: 0
      right: 0
      width: 50%
      margin: 0 auto
      max-width: 180px
      // max-width: 48vw

    &.active
      opacity: 1
      transition: all 0.6s ease 0.4s

</style>



// WEBPACK FOOTER //
// LoadingText.vue?26251ff8